module.exports = __webpack_public_path__ + "static/img/nav1.e21b3344.png";